function scrollPosition() {
    var container = document.getElementById("card-container");
    var leftButton = document.getElementById("left-arrow");
    var rightButton = document.getElementById("right-arrow");
    if (container) {
        if (container.scrollLeft == 0) {
            leftButton.classList.add("hidden");
        } else {
            leftButton.classList.remove("hidden");
        }

        if (container.scrollLeft + container.offsetWidth >= container.scrollWidth) {
            rightButton.classList.add("hidden");
        } else {
            rightButton.classList.remove("hidden");
        }
    }
}

function scrollPositionTimeout() {
    setInterval(scrollPosition, 50);
}

function scrollContainer(direction, elementId) {
    var container = document.getElementById(elementId);
    var scrollAmount = document.getElementById(elementId).offsetWidth + 15;
    if (container) {
        if (direction === 'left') {
            container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        } else {
            container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    }
}

function scrollToElement(element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function scrollToSection(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        scrollToElement(element);
    }
}

window.isElementScrollable = function (elementId) {
    const element = document.getElementById(elementId);
    if (!element) return false;

    const canScrollVertically = element.scrollHeight > element.clientHeight;

    return canScrollVertically;
};

window.scrollToBottom = function(id) {
    const el = document.getElementById(id);
    if (el) el.scrollTop = el.scrollHeight;
};

// Scroll Container Behavior
window.scrollToElementContainer = function (selector, behavior = "smooth", block = "start") {
    var element = document.querySelector(selector);
    if (element && typeof element.scrollIntoView === "function") {
        element.scrollIntoView({ behavior: behavior, block: block });
    }
}

window.scrollToElementContainerById = function (selector, behavior = "smooth", block = "start") {
    var element = document.getElementById(selector);
    if (element && typeof element.scrollIntoView === "function") {
        element.scrollIntoView({ behavior: behavior, block: block });
    }
}

// Scroll Counters
window.animateCountersOnScroll = () => {
    function animateCount(el, duration = 1500) {
        const target = +el.getAttribute("data-target");
        let current = 0;
        const increment = target / (duration / 16);

        if (el.textContent.replace("%", "") == target.toString()) return;

        function update() {
            current += increment;
            if (current < target) {
                el.textContent = Math.floor(current) + "%";
                requestAnimationFrame(update);
            } else {
                el.textContent = target + "%";
            }
        }

        update();
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCount(entry.target);
            } else {

                const target = entry.target.getAttribute("data-target");
                entry.target.textContent = "0%";
            }
        });
    }, { threshold: 0.5 });

    document.querySelectorAll('.counter').forEach(el => observer.observe(el));
};
